module.exports = __webpack_public_path__ + "img/CopyIcon.29c1bc42.svg";